import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { PagedSelectModule } from '@shared/components/paged-select/paged-select.module';
import { DirectivesModule } from 'mbs-ui-shared/src/lib/directives/directives.module';
import { UtilsModule } from 'mbs-ui-shared@utils/utils.module';
import { I18NextModule } from 'angular-i18next';
import { MbsUiKitModule } from 'mbs-ui-kit';
import { IterationCtrlButtonModule } from 'mbs-ui-shared@modules/iteration-ctrl-button/iteration-ctrl-button.module';
import { RmmSelectServiceModalComponent } from './rmm-select-service-modal.component';

@NgModule({
  declarations: [RmmSelectServiceModalComponent],
  imports: [
    CommonModule,
    MbsUiKitModule,
    I18NextModule,
    NgbTooltipModule,
    NgbDropdownModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule,
    UtilsModule,
    IterationCtrlButtonModule,
    PagedSelectModule
  ],
  providers: [],
  exports: [RmmSelectServiceModalComponent]
})
export class RmmSelectServiceModalModule {}
